export default __webpack_public_path__ + "static/media/ic_manage-card.6c579dcd.svg";